import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { deleteManageSecondment, getManageSecondmentList, ManageSecondmentActor, ManageSecondmentRow } from "../../../Services/ManageSecondments";
import ManageSecondmentsTable from "./ManageSecondmentsTable";

interface ManageSecondmentsListProps {
  actor: ManageSecondmentActor;
  rows: ManageSecondmentRow[];
  onChange: (rows: ManageSecondmentRow[]) => void;
}

export default function ManageSecondmentsList({ actor, rows, onChange }: ManageSecondmentsListProps): ReactElement {
  const navigate = useNavigate();

  async function remove(secId: number): Promise<void> {
    if (!window.confirm("Delete this Secondment ?")) {
      return;
    }
    await deleteManageSecondment(actor, secId);
    onChange(await getManageSecondmentList(actor));
  }

  return (
    <div className="stack">
      <div className="lead-band">
        Member Professionals can submit secondment listings that encompass the entire program or individual listings that identify different opportunities by length of stay, areas of practice, locations, professional age and experience, and any other filter used to differentiate within the secondment program offered by the firm. Because the secondment listing database can be searched by keywords, jurisdiction or practice industry, we encourage the information to be entered as text to optimize the search capabilities and specifically identify the secondment opportunities being realized.
      </div>
      <div className="flex flex-wrap">
        <NewButton text="Submit Secondment Opportunity" onClick={() => navigate("/manage_secondments?action=add")} />
      </div>
      <ManageSecondmentsTable rows={rows} onDelete={remove} />
      <div className="content-dots" aria-hidden="true"><span /><span /><span /></div>
    </div>
  );
}
